// @ts-check

/** @file Reorders BoardColumn frontend models through the backend command. */

import {BoardColumn} from "../../frontend-models/board-column.js"

/**
 * @typedef {object} BoardColumnReorderTarget
 * @property {string} id Board-column id.
 * @property {number} position Target one-based position.
 */

/**
 * Atomically reorders board columns through the backend collection command.
 * @param {BoardColumnReorderTarget[]} targets Final board-column positions.
 * @returns {Promise<BoardColumn[]>} Updated board columns.
 * @rejects {Error} When the backend command rejects.
 */
export default async function reorderBoardColumns(targets) {
  const response = await BoardColumn.reorder({targets})
  return response.boardColumns
}
